var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import _ from 'lodash';
import Moment from 'moment-timezone';
import { EventEmitter } from 'events';
import { ActionTypes, DATE_FORMAT } from 'constants/AdminConstants';
import { addProductSchema, updateAccountSchema, updateDataSchema, updateProductSchema, updatePlayerSchema, updateTeamSchema, updateGoalSchema, updateNotificationSchema } from 'types/actions/companyStateActions';
import { CompanyDataSchema } from './types';
import Dispatcher from '../../dispatcher/Dispatcher';
var CHANGE_EVENT = 'change';
var CompanyStore = /** @class */ (function (_super) {
    __extends(CompanyStore, _super);
    function CompanyStore() {
        var _this = _super.call(this) || this;
        _this.data = {};
        _this.registerDispatcher();
        return _this;
    }
    CompanyStore.prototype.registerDispatcher = function () {
        var _this = this;
        this.dispatchToken = Dispatcher.register(function (action) {
            switch (action.type) {
                case ActionTypes.UPDATE_COMPANY_STORE:
                    _this.handleUpdateAction(action);
                    break;
                case ActionTypes.SHOW_GLOBAL_LOADER:
                    _this.showLoader();
                    break;
                case ActionTypes.ADD_PRODUCT:
                    _this.handleAddProductAction(action);
                    break;
                case ActionTypes.UPDATE_ACCOUNT:
                    _this.handleUpdateAccountAction(action);
                    break;
                case ActionTypes.UPDATE_PRODUCT:
                    _this.handleUpdateProductAction(action);
                    break;
                case ActionTypes.UPDATE_PLAYER:
                    _this.handleUpdatePlayerAction(action);
                    break;
                case ActionTypes.UPDATE_TEAM:
                    _this.handleUpdateTeamAction(action);
                    break;
                case ActionTypes.UPDATE_GOAL:
                    _this.handleUpdateGoalAction(action);
                    break;
                case ActionTypes.UPDATE_NOTIFICATION:
                    _this.handleUpdateNotificationAction(action);
                    break;
                default:
                // do nothing
            }
        });
    };
    CompanyStore.prototype.init = function (initData) {
        var _a;
        var parsingResult = CompanyDataSchema.safeParse(initData);
        if (!parsingResult.success) {
            console.error('Invalid init data in CompanyStore:', parsingResult.error);
            // Still initialize with the raw data to prevent app from breaking
            // Coerce IDs to numbers to ensure type consistency
            var rawData = initData;
            this.data = __assign(__assign(__assign({}, this.data), rawData), { users: ((_a = rawData.users) === null || _a === void 0 ? void 0 : _a.map(function (user) { return (__assign(__assign({}, user), { id: Number(user.id), account_id: Number(user.account_id), role_id: Number(user.role_id) })); })) || [], current_user: rawData.current_user ? __assign(__assign({}, rawData.current_user), { id: Number(rawData.current_user.id), account_id: Number(rawData.current_user.account_id) }) : rawData.current_user });
            return;
        }
        this.data = __assign(__assign({}, this.data), parsingResult.data);
    };
    CompanyStore.prototype.emitChange = function () {
        this.emit(CHANGE_EVENT);
    };
    CompanyStore.prototype.addChangeListener = function (callback) {
        this.on(CHANGE_EVENT, callback);
    };
    CompanyStore.prototype.removeChangeListener = function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    };
    CompanyStore.prototype.getCompanyInfo = function () {
        return this.data;
    };
    CompanyStore.prototype.getFirstPlayerId = function () {
        if (!this.data.users) {
            return null;
        }
        return this.data.users[0].id;
    };
    CompanyStore.prototype.getCurrentUser = function () {
        if (!this.data.current_user || !this.data.current_user.id) {
            return null;
        }
        return this.getPlayer(this.data.current_user.id);
    };
    CompanyStore.prototype.getAccount = function () {
        var _a;
        return (_a = this.data.account) !== null && _a !== void 0 ? _a : null;
    };
    CompanyStore.prototype.getAccountId = function () {
        var _a, _b;
        return (_b = (_a = this.data.account) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
    };
    CompanyStore.prototype.getPlayer = function (id) {
        if (!this.data.users || !this.data.current_user || !this.data.current_user.id) {
            return null;
        }
        var player = this.data.users.find(function (user) { return user.id === id; });
        if (!player) {
            return null;
        }
        return __assign(__assign({}, player), { isCurrentUser: player.id === this.data.current_user.id, products: this.getProductsForPlayer(id) });
    };
    CompanyStore.prototype.getGame = function (id) {
        var _a, _b;
        var parsed = parseInt(id.toString(), 10);
        if (!this.data.games) {
            return null;
        }
        var game = this.data.games.find(function (_a) {
            var settings = _a.settings;
            return parseInt(settings.id, 10) === parsed;
        });
        if (!game) {
            return null;
        }
        var playerDetails = ((_a = game.users) === null || _a === void 0 ? void 0 : _a.length) ?
            this.data.users.filter(function (_a) {
                var _b;
                var userId = _a.id;
                return (_b = game.users) === null || _b === void 0 ? void 0 : _b.includes(userId);
            }) :
            [];
        var teamDetails = ((_b = game.teams) === null || _b === void 0 ? void 0 : _b.length) ?
            this.data.teams.filter(function (_a) {
                var _b;
                var teamId = _a.id;
                return (_b = game.teams) === null || _b === void 0 ? void 0 : _b.includes(teamId);
            }) :
            [];
        return __assign(__assign({}, game), { player_details: playerDetails, team_details: teamDetails });
    };
    CompanyStore.prototype.generateAllPlayersTeam = function () {
        var _a, _b;
        return {
            // This was in original code, but not sure why "account_id" instead of "account.id"
            account_id: (_b = (_a = this.data.account) === null || _a === void 0 ? void 0 : _a.account_id) !== null && _b !== void 0 ? _b : 0,
            add_time: '0000-00-00 00:00:00',
            deactivated: false,
            id: 0,
            is_all_players_team: true,
            team_name: 'All Players',
            update_time: '0000-00-00 00:00:00',
            user_ids: this.getActiveUserIds()
        };
    };
    CompanyStore.prototype.getActiveUserIds = function () {
        return this.data.users
            .filter(function (user) { return !user.deactivated; })
            .map(function (user) { return user.id; });
    };
    CompanyStore.prototype.getFirstTeamId = function () {
        if (!this.data.teams || this.data.teams.length === 0) {
            return null;
        }
        return this.data.teams[0].id;
    };
    CompanyStore.prototype.getTeam = function (id) {
        if (!this.data.teams) {
            return null;
        }
        var team = this.data.teams.find(function (_a) {
            var teamId = _a.id;
            return teamId === id;
        });
        if (!team) {
            return null;
        }
        return __assign(__assign({}, team), { users: this.getPlayers(team.user_ids) });
    };
    CompanyStore.prototype.getPlayers = function (playerIds) {
        return this.data.users.filter(function (user) { return playerIds.includes(user.id); });
    };
    CompanyStore.prototype.getTeams = function () {
        return [{ name: 'All Players' }];
    };
    CompanyStore.prototype.getProductsForPlayer = function (id) {
        var goalsByProductId = this.data.goals
            .filter(function (goal) { return goal.user_id === id; })
            .reduce(function (acc, goal) {
            acc[goal.product_id] = goal;
            return acc;
        }, {});
        return this.data.products.map(function (product) { return ({
            id: product.id,
            product_name: product.product_name,
            value_required: product.value_required,
            value_label: product.value_label,
            goal: goalsByProductId[product.id]
        }); });
    };
    CompanyStore.prototype.getGoalsForPlayer = function (id) {
        return this.data.goals.filter(function (goal) { return goal.user_id === id; });
    };
    CompanyStore.prototype.handleUpdateAction = function (action) {
        var parsingResult = updateDataSchema.safeParse(action);
        if (!parsingResult.success) {
            console.error('Invalid update action in CompanyStore:', parsingResult.error);
            // Once we migrate the whole codebase to TypeScript, we can remove this
            this.update(action.data);
            return;
        }
        this.update(parsingResult.data.data);
    };
    CompanyStore.prototype.handleAddProductAction = function (action) {
        var parsingResult = addProductSchema.safeParse(action);
        if (!parsingResult.success) {
            console.error('Invalid add product action in CompanyStore:', parsingResult.error);
            return;
        }
        this.addProduct(parsingResult.data.data);
    };
    CompanyStore.prototype.handleUpdateAccountAction = function (action) {
        var parsingResult = updateAccountSchema.safeParse(action);
        if (!parsingResult.success) {
            console.error('Invalid update account action in CompanyStore:', parsingResult.error);
            return;
        }
        this.updateAccount(parsingResult.data.data);
    };
    CompanyStore.prototype.handleUpdateProductAction = function (action) {
        var parsingResult = updateProductSchema.safeParse(action);
        if (!parsingResult.success) {
            console.error('Invalid update product action in CompanyStore:', parsingResult.error);
            return;
        }
        var _a = parsingResult.data, id = _a.id, data = _a.data;
        this.updateProduct(id, data);
    };
    CompanyStore.prototype.handleUpdatePlayerAction = function (action) {
        var parsingResult = updatePlayerSchema.safeParse(action);
        if (!parsingResult.success) {
            console.error('Invalid update player action in CompanyStore:', parsingResult.error);
            return;
        }
        var _a = parsingResult.data, id = _a.id, data = _a.data;
        this.updatePlayer(id, data);
    };
    CompanyStore.prototype.handleUpdateTeamAction = function (action) {
        var parsingResult = updateTeamSchema.safeParse(action);
        if (!parsingResult.success) {
            console.error('Invalid update team action in CompanyStore:', parsingResult.error);
            return;
        }
        var _a = parsingResult.data, id = _a.id, data = _a.data;
        this.updateTeam(id, data);
    };
    CompanyStore.prototype.handleUpdateGoalAction = function (action) {
        var parsingResult = updateGoalSchema.safeParse(action);
        if (!parsingResult.success) {
            console.error('Invalid update goal action in CompanyStore:', parsingResult.error);
            return;
        }
        var data = parsingResult.data.data;
        this.updateGoal(data);
    };
    CompanyStore.prototype.handleUpdateNotificationAction = function (action) {
        var parsingResult = updateNotificationSchema.safeParse(action);
        if (!parsingResult.success) {
            console.error('Invalid update notification action in CompanyStore:', parsingResult.error);
            return;
        }
        var data = parsingResult.data.data;
        this.updateNotification(data);
    };
    CompanyStore.prototype.update = function (updateData) {
        var updateVersion = updateData === null || updateData === void 0 ? void 0 : updateData.version;
        if (updateVersion !== undefined &&
            (!this.data.version ||
                (updateVersion > this.data.version))) {
            this.data = __assign(__assign(__assign({}, this.data), updateData), { global_loader: false });
            this.emitChange();
        }
        else if (this.data.global_loader) {
            // Prevent runaway loading animation
            this.data.global_loader = false;
            this.emitChange();
        }
    };
    CompanyStore.prototype.getCurrentVersion = function () {
        return this.data.version;
    };
    CompanyStore.prototype.showLoader = function () {
        this.data.global_loader = true;
        this.emitChange();
    };
    CompanyStore.prototype.isLoading = function () {
        return !!this.data.global_loader;
    };
    CompanyStore.prototype.getTimeZone = function () {
        var _a, _b;
        return (_b = (_a = this.data.account) === null || _a === void 0 ? void 0 : _a.timezone) !== null && _b !== void 0 ? _b : 'UTC';
    };
    CompanyStore.prototype.getCurrentTimeStamp = function () {
        var _a, _b;
        var timezone = (_b = (_a = this.data.account) === null || _a === void 0 ? void 0 : _a.timezone) !== null && _b !== void 0 ? _b : 'UTC';
        return Moment.tz(timezone).format(DATE_FORMAT);
    };
    CompanyStore.prototype.addProduct = function (product) {
        // If the product is already in the company store, don't add it again
        if (this.data.products.find(function (p) { return p.id === product.id; })) {
            return;
        }
        if (!this.data.current_user || !this.data.current_user.account_id) {
            throw new Error('Current user not found');
        }
        var timestamp = this.getCurrentTimeStamp();
        var newProduct = __assign(__assign({}, product), { account_id: this.data.current_user.account_id, deactivated: false, add_time: timestamp, update_time: timestamp, value_required: false, value_label: null });
        this.data.products.push(newProduct);
        this.emitChange();
    };
    CompanyStore.prototype.updateAccount = function (account) {
        _.extend(this.data.account, account);
        this.emitChange();
    };
    CompanyStore.prototype.updateProduct = function (id, product) {
        var productIndex = this.data
            .products
            .findIndex(function (_a) {
            var productId = _a.id;
            return productId === id;
        });
        if (productIndex !== -1) {
            _.extend(this.data.products[productIndex], product);
            this.emitChange();
        }
    };
    CompanyStore.prototype.updatePlayer = function (id, playerUpdate) {
        var playerMatch = this.data.users.find(function (player) { return player.id === id; });
        if (playerMatch) {
            _.extend(playerMatch, playerUpdate);
            this.emitChange();
        }
    };
    CompanyStore.prototype.updateTeam = function (id, teamUpdate) {
        var parsed = parseInt(id, 10);
        var teamMatch = this.data.teams.find(function (_a) {
            var teamId = _a.id;
            return teamId === parsed;
        });
        if (teamMatch) {
            _.extend(teamMatch, teamUpdate);
            this.emitChange();
        }
    };
    CompanyStore.prototype.updateGoal = function (goal) {
        var productId = goal.product_id;
        var userId = goal.user_id;
        var goalIndex = this.data.goals.findIndex(function (_a) {
            var goalProductId = _a.product_id, goalUserId = _a.user_id;
            return goalProductId === productId && goalUserId === userId;
        });
        if (goalIndex !== -1) {
            _.extend(this.data.goals[goalIndex], goal);
            this.emitChange();
        }
    };
    CompanyStore.prototype.updateNotification = function (notification) {
        var notificationId = notification.id;
        var notificationIndex = this.data.notifications.findIndex(function (n) { return n.id === notificationId; });
        if (notificationIndex !== -1) {
            _.extend(this.data.notifications[notificationIndex], notification);
            this.emitChange();
        }
    };
    CompanyStore.prototype.getAllGamesList = function () {
        return this.data.games_list.all;
    };
    return CompanyStore;
}(EventEmitter));
var store = new CompanyStore();
export default store;
